import { RootState } from 'store/index'

export const isLoggedIn = ({ auth }: RootState) => auth.loggedIn
export const isLoading = ({ auth }: RootState) => auth.loading
export const isLoggingOut = ({ auth }: RootState) => auth.loggingOut
export const getLogoutParams = ({ auth }: RootState) => auth.logoutParams
export const getError = ({ auth }: RootState) => auth.error
